import React, { useEffect } from 'react'
import {
  Box,
  Typography,
  TextField,
  IconButton,
  Button,
} from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import { TrashIcon } from '../../icons'
import TextEditor from '../editor/TextEditor'
import ValidationErrorText from '../common/ValidationErrorText'
import { defaultFaqVal } from '../../containers/course-container/reducer/courseFieldsDefaultValue'

const FaqsQuestion = ({ label, value = [], onChange, readOnly = false,fieldErrors,fieldError,fieldType }) => {
  // Always keep at least one FAQ item
  const faqs =  value

  const handleQuestionChange = (index) => (e) => {
    if (readOnly) return
    onChange(
      faqs.map((faq, i) =>
        i === index ? { ...faq, question: e.target.value } : faq
      )
    )
  }

  const handleAnswerChange = (index) => (newAnswer) => {
    if (readOnly) return
    onChange(
      faqs.map((faq, i) =>
        i === index ? { ...faq, answer: newAnswer } : faq
      )
    )
  }

  const handleDelete = (index) => () => {
    if (readOnly) return
    const updated = faqs.filter((_, i) => i !== index)
    onChange(updated)
  }

  const handleAddMore = () => {
    if (readOnly) return
    onChange([...faqs, ...defaultFaqVal])
  }

  return (
    <Box>
      <Typography fontSize="14px" fontWeight="500" mb={1}>
        {label}
      </Typography>
      {faqs.map((faq, index) => (
        <Box
          key={index}
          sx={{
            mb: 2,
            p: 2,
            border: '1px solid #eee',
            borderRadius: 2,
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
            position: 'relative'
          }}
        >
          <Box display="flex" alignItems="center" gap={1}>
            <Typography fontWeight="bold">{index + 1}.</Typography>
            <Box width={"100%"}>
            <TextField
              placeholder="Enter Question"
              fullWidth
              size="small"
              value={faq.question}
              onChange={handleQuestionChange(index)}
              InputProps={{ readOnly }}
              disabled={readOnly}
              sx={{
                '& .MuiInputBase-root': {
                  height: 38,
                  fontSize: '13px',
                },
                '& input': {
                  fontSize: '13px',
                },
              }}
            />
          <ValidationErrorText error={fieldErrors?.[`${fieldType}[${index}].question`]}/>  
            </Box>
            {!readOnly && (
              <IconButton
                onClick={handleDelete(index)}
                // disabled={faqs.length === 1}
                sx={{ ml: 1 }}
                aria-label={`Delete FAQ ${index + 1}`}
              >
                <TrashIcon />
              </IconButton>
            )}
          </Box>
          <TextEditor
            value={faq.answer}
            onChange={handleAnswerChange(index)}
            placeholder="Enter Answer"
            readOnly={readOnly}
          />
          <ValidationErrorText error={fieldErrors?.[`${fieldType}[${index}].answer`]}/>  
        </Box>
      ))}
      {!readOnly && (
        <Button
          sx={{
            color: '#1075FF',
            border: '1px solid #1075FF',
            textTransform: 'capitalize',
            px: 3,
            mt: 1,
          }}
          onClick={handleAddMore}
          startIcon={<AddIcon />}
        >
          Add More
        </Button>
      )}
    </Box>
  )
}

export default FaqsQuestion
